// /* eslint-disable react-hooks/exhaustive-deps */
// /* eslint-disable @typescript-eslint/no-unused-vars */
// "use client";

// import React, { useEffect, useState } from "react";
// import { usePermission } from "../../../hooks/usePermissionTabs";
// import { useLanguage } from "../../../context/LanguageContext";
// import Pagination from "../../../components/common/Pagination";
// import { IconPencil, IconSearch, IconX } from "@tabler/icons-react";
// import RequestModal from "./RequestModal";
// import CredentialsModal from "./CredentialsModal";
// import EditViewCredentialsModal from "./EditViewCredentialsModal";
// import IntegrationSkeleton from "../../../components/skeleton/IntegrationSkeleton";
// import { useSelector } from "react-redux";
// import {
//   useCancelChannelMutation,
//   useConnectChannelMutation,
//   useEditChannelMutation,
//   useEditNaqelCredentialsMutation,
//   useEditAramexCredentialsMutation,
//   useRequestChannelMutation,
//   useEditZidCredentialsMutation,
//   useEditJtCredentialsMutation,
// } from "../../../apis/integrationApis";
// import toast from "react-hot-toast";
// import LoaderButton from "../../../components/common/LoaderButton";
// import CancelModal from "./CancelModal";
// import { useForm } from "react-hook-form";
// import WebhookModal from "./WebhookModal";
// import { useNavigate } from "react-router-dom";
// import DropdownFilter from "../../../components/common/DropdownFilter";

// type ChannelStatus =
//   | "NotRequested"
//   | "Requested"
//   | "Approved"
//   | "Connected"
//   | "Rejected"
//   | "Installed";

// interface Channel {
//   id: string;
//   platformId: string;
//   companyName: string;
//   companyLogo: string;
//   appId: string;
//   secretKey: string;
//   clientId: string;
//   description: string;
//   status: ChannelStatus;
//   requestId: string;
//   authKey?: string;
//   serviceCode?: string;
//   isPudo?: string;
//   channelType: string;
//   shippingPartnerId: string;
//   accountType?: string;
//   apiVersion?: string;
// }

// interface Props {
//   isPending: boolean;
//   data: {
//     channels: Channel[];
//     totalPages: number;
//   };
//   fetchData: () => void;
//   tab: string;
// }

// type ModalType =
//   | "request"
//   | "credentials"
//   | "edit"
//   | "cancel"
//   | "webhook"
//   | "install"
//   | "installed"
//   | null;

// export default function SalesChannelTab({
//   isPending,
//   data,
//   fetchData,
//   tab,
// }: Props) {
//   const { t } = useLanguage();
//   const { allowed: canCreateIntegration } = usePermission(
//     "integration",
//     "create",
//   );
//   const { allowed: canUpdateIntegration } = usePermission(
//     "integration",
//     "update",
//   );
//   const [modalType, setModalType] = useState<ModalType>(null);
//   const [isOpen, setIsOpen] = useState<boolean>(false);
//   const [webhookUrl, setWebhookUrl] = useState<string>("");
//   const [channelId, setChannelId] = useState<string>("");
//   const [platformId, setPlatformId] = useState<string>("");
//   const [requestId, setRequestId] = useState<string>("");
//   const [companyName, setCompanyName] = useState<string>("");
//   const [channelType, setChannelType] = useState<string>("");
//   const isSidebarOpen = modalType !== null || isOpen;
//   const [showSearch, setShowSearch] = useState<boolean>(false);
//   const [value, setValue] = useState<string | undefined>("");

//   const navigate = useNavigate();

//   const setDropdownValue = (data: string | undefined) => {
//     setValue(data);
//   };

//   type FormValues = {
//     accountNumber?: string;
//     authKey?: string;
//     clientId?: string;
//     secretKey: string;
//     appId: string;
//     serviceCode?: string;
//     isPudo?: string;
//     shopDomain?: string;
//     accessToken?: string;
//     // Naqel
//     userName?: string;
//     password?: string;
//     customerCode?: string;
//     branchCode?: string;
//     accountPin?: string;
//     accountCountryCode?: string;
//     accountEntity?: string;
//     paymentType?: string;
//     productGroup?: string;
//     productType?: string;
//     clientSecret?: string;
//     apiAccount?: string;
//     privateKey?: string;
//   };

//   const {
//     register,
//     handleSubmit,
//     reset,
//     formState: { errors },
//   } = useForm<FormValues>();

//   const {
//     register: editRegister,
//     handleSubmit: editSubmit,
//     setValue: setEditValue,
//     reset: editReset,
//     formState: { errors: editErrors },
//   } = useForm<FormValues>();

//   const { mutate, isPending: isRequestPending } =
//     useRequestChannelMutation(channelId);
//   const { mutate: connectionMutate, isPending: isConnectionPending } =
//     useConnectChannelMutation(
//       channelType === "Shipping"
//         ? `/smsa-connection`
//         : channelType === "Shoapify"
//           ? `/shoapify-connection`
//           : channelType === "Connection Account"
//             ? "/established/connection-two-account"
//             : "",
//     );
//   const { mutate: editConnectionMutate } = useEditChannelMutation(
//     channelType === "Shipping"
//       ? `/smsa-connection/${platformId}`
//       : channelType === "Shoapify"
//         ? `/shoapify-connection/${platformId}`
//         : channelType === "Connection Account"
//           ? "/established/connection-two-account"
//           : "",
//   );
//   const { mutate: editNaqelMutate, isPending: isNaqelEditPending } =
//     useEditNaqelCredentialsMutation();
//   const { mutate: editAramexMutate, isPending: isAramexEditPending } =
//     useEditAramexCredentialsMutation();
//   const { mutate: editZidMutate, isPending: isZidEditPending } =
//     useEditZidCredentialsMutation();
//   const { mutate: editJtMutate, isPending: isJtEditPending } =
//     useEditJtCredentialsMutation();
//   const profile = useSelector((state: any) => state.auth.profile);
//   const { mutate: cancelMutate, isPending: isCancelPending } =
//     useCancelChannelMutation();

//   const toggleModal = (type: ModalType | null) => setModalType(type);

//   const handleRequest = () => {
//     if (!canCreateIntegration) {
//       toast.error("You do not have permission to request integrations");
//       return;
//     }
//     mutate(undefined, {
//       onSuccess: () => {
//         toggleModal(null);
//         fetchData();
//       },
//       onError: (error) => {
//         console.log(error, "error");
//         toast.error(`${error}`);
//       },
//     });
//   };

//   const handleCancel = () => {
//     if (!canUpdateIntegration) {
//       toast.error("You do not have permission to cancel integration requests");
//       return;
//     }
//     cancelMutate(
//       { channelId, requestId },
//       {
//         onSuccess: () => {
//           toggleModal(null);
//           fetchData();
//         },
//         onError: (error) => {
//           console.log(error, "error");
//           toast.error(`${error}`);
//         },
//       },
//     );
//   };

//   const handleConnect = (data: any) => {
//     connectionMutate(
//       { channelId, ...data },
//       {
//         onSuccess: (res) => {
//           if (res?.webhookUrl) {
//             setWebhookUrl(res?.webhookUrl);
//             setIsOpen(true);
//           }
//           toggleModal(null);
//           reset();
//           fetchData();
//         },
//         onError: (error) => {
//           console.log(error, "error");
//           toast.error(`${error}`);
//         },
//       },
//     );
//   };

//   const handleEdit = (data: any) => {
//     const ctLower = channelType.toLowerCase();
//     if (ctLower.includes("naqel")) {
//       editNaqelMutate(
//         {
//           credentials: {
//             userName: data.userName ?? "",
//             password: data.password ?? "",
//             customerCode: data.customerCode ?? "",
//             branchCode: data.branchCode ?? "",
//           },
//           clientId: profile?.id ?? "",
//           connectionId: platformId,
//         },
//         {
//           onSuccess: () => {
//             toast.success("Naqel credentials updated!");
//             toggleModal(null);
//             editReset();
//             fetchData();
//           },
//           onError: (error) => {
//             console.log(error, "error");
//             toast.error(`${error}`);
//           },
//         },
//       );
//     } else if (ctLower.includes("aramex")) {
//       editAramexMutate(
//         {
//           credentials: {
//             UserName: data.userName ?? "",
//             Password: data.password ?? "",
//             AccountNumber: data.accountNumber ?? "",
//             AccountPin: data.accountPin ?? "",
//             AccountEntity: data.accountEntity ?? "",
//             AccountCountryCode: data.accountCountryCode ?? "",
//             PaymentType: data.paymentType ?? "",
//             ProductGroup: data.productGroup ?? "",
//             ProductType: data.productType ?? "",
//           },
//           clientId: profile?.id ?? "",
//           connectionId: platformId,
//         },
//         {
//           onSuccess: () => {
//             toast.success("Aramex credentials updated!");
//             toggleModal(null);
//             editReset();
//             fetchData();
//           },
//           onError: (error: any) => {
//             console.log(error, "error");
//             toast.error(`${error}`);
//           },
//         },
//       );
//     } else if (ctLower.includes("zid")) {
//       editZidMutate(
//         {
//           credentials: {
//             clientId: data.clientId ?? "",
//             clientSecret: data.clientSecret ?? "",
//             appId: data.appId ?? "",
//           },
//           clientId: profile?.id ?? "",
//           channelId: platformId,
//         },
//         {
//           onSuccess: () => {
//             toast.success("Zid credentials updated!");
//             toggleModal(null);
//             editReset();
//             fetchData();
//           },
//           onError: (error) => {
//             console.log(error, "error");
//             toast.error(`${error}`);
//           },
//         },
//       );
//     } else if (ctLower.includes("j&t") || ctLower.includes("jt express")) {
//       editJtMutate(
//         {
//           credentials: {
//             customerCode: data.customerCode ?? "",
//             apiAccount: data.apiAccount ?? "",
//             privateKey: data.privateKey ?? "",
//           },
//           clientId: profile?.id ?? "",
//           connectionId: platformId,
//         },
//         {
//           onSuccess: () => {
//             toast.success("J&T credentials updated!");
//             toggleModal(null);
//             editReset();
//             fetchData();
//           },
//           onError: (error) => {
//             console.log(error, "error");
//             toast.error(`${error}`);
//           },
//         },
//       );
//     } else {
//       editConnectionMutate(
//         { channelId, ...data, id: platformId },
//         {
//           onSuccess: () => {
//             toggleModal(null);
//             editReset();
//             fetchData();
//           },
//           onError: (error) => {
//             console.log(error, "error");
//             toast.error(`${error}`);
//           },
//         },
//       );
//     }
//   };

//   const callAction = (): void => {
//     switch (modalType) {
//       case "request":
//         handleRequest();
//         break;
//       case "cancel":
//         handleCancel();
//         break;
//       case "credentials":
//         handleSubmit(handleConnect)();
//         break;
//       case "edit":
//         editSubmit(handleEdit)();
//         break;
//     }
//   };

//   const getModalTitle = (): string => {
//     switch (modalType) {
//       case "request":
//         return companyName;
//       case "cancel":
//         return t("Cancel Request");
//       case "credentials":
//       case "edit":
//         return companyName;
//       default:
//         return "";
//     }
//   };

//   const getActionButtonText = (): string | React.ReactElement => {
//     switch (modalType) {
//       case "request":
//         return isRequestPending ? (
//           <LoaderButton text={t("Requesting...")} />
//         ) : (
//           t("Request Integration")
//         );
//       case "cancel":
//         return isCancelPending ? (
//           <LoaderButton text={t("Confirming...")} />
//         ) : (
//           t("Confirm")
//         );
//       case "credentials":
//         return isRequestPending ? (
//           <LoaderButton text={t("Submitting...")} />
//         ) : tab === "Shipping" ? (
//           t("Test Connection")
//         ) : (
//           t("Submit Credentials")
//         );
//       case "edit":
//         return t("Update");
//       default:
//         return "";
//     }
//   };

//   const renderModalContent = () => {
//     switch (modalType) {
//       case "request":
//         return <RequestModal />;
//       case "cancel":
//         return <CancelModal />;
//       case "credentials":
//         return <CredentialsModal channelId={channelId} />;
//       case "edit":
//         return (
//           <EditViewCredentialsModal
//             register={editRegister}
//             errors={editErrors}
//             reset={editReset}
//             tab={
//               tab !== "All"
//                 ? tab
//                 : channelType === "Shipping"
//                   ? "Shipping"
//                   : channelType === "Shoapify"
//                     ? "Shoapify"
//                     : channelType === "Connection Account"
//                       ? "Connection Account"
//                       : "Sales"
//             }
//             channelType={channelType}
//             clientId={profile?.id}
//           />
//         );
//       default:
//         return null;
//     }
//   };

//   const getButtonProps = (status: ChannelStatus) => {
//     switch (status) {
//       case "NotRequested":
//         return {
//           label: "Request",
//           style:
//             "bg-[#FBD037]/20 hover:bg-[#FBD037] border-[#FBD037] text-[#212121] rounded-md",
//           modal: "request" as ModalType,
//         };
//       case "Requested":
//         return {
//           label: "Cancel",
//           style: "bg-[#212121] text-white rounded-md",
//           modal: "cancel" as ModalType,
//         };
//       case "Approved":
//         return {
//           label: "Install",
//           style: "bg-[#FBD037] border-[#FBD037] text-[#212121] rounded-md",
//           modal: "credentials" as ModalType,
//         };
//       case "Connected":
//         return {
//           label: "Connected",
//           style:
//             "bg-[#20BF55]/20 text-[#20BF55] border border-[#20BF55] rounded-full ",
//           modal: null,
//         };
//       case "Rejected":
//         return {
//           label: "Request",
//           style: "bg-[#FBD037] border-[#FBD037] text-[#212121] rounded-md",
//           modal: "request" as ModalType,
//         };
//       case "Installed":
//         return {
//           label: "Connect",
//           style: "bg-blue-400 text-white hover:bg-[#333333] rounded-md",
//           modal: "connect" as ModalType,
//         };
//       default:
//         return {
//           label: "Install",
//           style:
//             "border bg-[#FBD037]/20 border-[#FBD037] text-[#212121] hover:bg-[#FBD037] hover:text-[#212121] rounded-md",
//           modal: "install" as ModalType,
//         };
//     }
//   };

//   useEffect(() => {
//     setEditValue("serviceCode", "EDDL");
//   }, []);

//   return (
//     <>
//       <div className="2xl:space-y-6 space-y-4">
//         <div className="grid grid-cols-12 gap-6">
//           <div
//             className={`transition-all duration-300 ${
//               isSidebarOpen ? "col-span-7" : "col-span-12"
//             }`}
//           >
//             <div className="bg-white rounded-3xl border border-gray-100 shadow-sm p-6 space-y-4">
//               <div className="flex flex-col lg:flex-row lg:items-center justify-between gap-4">
//                 <div className="bg-[#FBD037] text-[#131327] font-black text-sm px-3.5 py-1.5 rounded-xl tracking-wider shadow-sm select-none">
//                   {t("Integration")}
//                 </div>

//                 <div className="flex items-center flex-wrap gap-2.5">
//                   <div
//                     onClick={() => {
//                       if (!showSearch) {
//                         setShowSearch(true);
//                       }
//                     }}
//                     className={`flex items-center transition-all duration-300 ease-in-out border border-slate-200 rounded-md bg-white shadow-sm h-8 ${
//                       showSearch
//                         ? "w-64 px-2 cursor-default"
//                         : "w-8 justify-center cursor-pointer"
//                     }`}
//                   >
//                     <button
//                       onClick={(e) => {
//                         e.stopPropagation();
//                         setShowSearch(!showSearch);
//                       }}
//                       className="flex items-center justify-center text-slate-700 focus:outline-none flex-shrink-0"
//                       title={t("Search")}
//                     >
//                       <IconSearch size={17} stroke={2.5} />
//                     </button>
//                     {showSearch && (
//                       <>
//                         <input
//                           type="text"
//                           placeholder={t("Search...")}
//                           autoFocus
//                           className="flex-1 ml-2 bg-transparent text-xs text-slate-800 placeholder-slate-400 outline-none border-none"
//                         />
//                         <button
//                           onClick={(e) => {
//                             e.stopPropagation();
//                             setShowSearch(false);
//                           }}
//                           className="flex items-center justify-center p-0.5 ml-1 text-slate-400 hover:text-slate-600 focus:outline-none flex-shrink-0"
//                           title={t("Clear & Close")}
//                         >
//                           <IconX size={14} stroke={2.5} />
//                         </button>
//                       </>
//                     )}
//                   </div>
//                   <DropdownFilter
//                     setValue={setDropdownValue}
//                     value={value}
//                     filterheadings={[
//                       { id: "", type: "All", value: "" },
//                       {
//                         id: "Requested",
//                         type: "Requested",
//                         value: "Requested",
//                       },
//                       { id: "Approved", type: "Approved", value: "Approved" },
//                       {
//                         id: "Connected",
//                         type: "Connected",
//                         value: "Connected",
//                       },
//                     ]}
//                   />
//                   <div className="flex items-center gap-2 px-3 py-2 bg-blue-50/80 border border-blue-100 rounded-md text-xs font-bold text-blue-700 shadow-sm select-none">
//                     <span className="text-slate-500">
//                       {t("Total")}:{" "}
//                       <span className="text-blue-700 bg-blue-50 border border-blue-100 px-1.5 py-0.5 rounded">
//                         5
//                       </span>
//                     </span>
//                     <span className="h-3 w-px bg-blue-200" />
//                     <span className="text-slate-500">
//                       {t("Connected")}:{" "}
//                       <span className="text-green-700 bg-blue-50 border border-blue-100 px-1.5 py-0.5 rounded">
//                         2
//                       </span>
//                     </span>
//                     <span className="h-3 w-px bg-blue-200" />
//                     <span className="text-slate-500">
//                       {t("Request")}:{" "}
//                       <span className="text-yellow-700 bg-blue-50 border border-blue-100 px-1.5 py-0.5 rounded">
//                         2
//                       </span>
//                     </span>
//                     <span className="h-3 w-px bg-blue-200" />
//                     <span className="text-slate-500">
//                       {t("Connect")}:{" "}
//                       <span className="text-sky-700 bg-blue-50 border border-blue-100 px-1.5 py-0.5 rounded">
//                         1
//                       </span>
//                     </span>
//                   </div>
//                 </div>
//               </div>
//               <div
//                 className={
//                   isSidebarOpen
//                     ? "grid 2xl:grid-cols-3 lg:grid-cols-3 md:grid-cols-2 grid-cols-1 gap-6 w-full"
//                     : "grid 2xl:grid-cols-5 lg:grid-cols-4 md:grid-cols-3 grid-cols-1 gap-6 w-full"
//                 }
//               >
//                 {isPending
//                   ? Array.from({ length: 6 }, (_, idx) => (
//                       <IntegrationSkeleton key={idx} />
//                     ))
//                   : data?.channels?.length > 0 &&
//                     data?.channels.map((channel: any) => {
//                       const { label, style, modal } = getButtonProps(
//                         channel?.status,
//                       );
//                       return (
//                         <div
//                           key={channel?.id}
//                           className="bg-white rounded-lg p-4 2xl:flex gap-4 border"
//                         >
//                           <div className="space-y-4 flex flex-col justify-between w-full">
//                             <div className="flex items-center gap-4">
//                               <img
//                                 src={
//                                   channel?.companyLogo ||
//                                   "https://cdn-1.webcatalog.io/catalog/salla-sa/salla-sa-icon-filled-256.webp?v=1751244872409"
//                                 }
//                                 alt={channel?.companyName}
//                                 className="size-16 rounded-xl border shadow-sm object-contain flex-shrink-0"
//                               />
//                               <div className="flex flex-row justify-between items-start w-full">
//                                 <div>
//                                   <h2 className="text-sm font-medium text-[#212121]">
//                                     {channel?.companyName}
//                                   </h2>
//                                   <p className="text-xs line-clamp-3">
//                                     Lorem ipsum dolor, sit amet consectetur
//                                     adipisicing elit. Suscipit nulla explicabo
//                                     sunt officia at, totam cupiditate fugit
//                                     nostrum, nobis quae maxime deleniti, a animi
//                                     ratione veniam voluptatem modi quod itaque?
//                                   </p>
//                                   <span className="text-[11px] font-medium text-gray-900 bg-slate-100 w-fit py-1 px-2 rounded-lg">
//                                     {channel?.channelType?.toUpperCase()}
//                                   </span>
//                                 </div>
//                                 {label === "Connected" && (
//                                   <span className="text-[11px] text-[#20BF55] border-[0.5px] border-[#20BF55] font-medium px-1 py-0.5 rounded-full bg-[#20BF55]/20">
//                                     {t(channel?.status)}
//                                   </span>
//                                 )}
//                               </div>
//                             </div>
//                             <div className="border-t" />
//                             <div className="flex items-center justify-end gap-3">
//                               {label &&
//                                 label !== "Connected" &&
//                                 (() => {
//                                   const isCreateAction =
//                                     channel?.status === "NotRequested" ||
//                                     channel?.status === "Approved" ||
//                                     channel?.status === "Rejected";
//                                   const hasActionPermission = isCreateAction
//                                     ? canCreateIntegration
//                                     : canUpdateIntegration;
//                                   return (
//                                     <button
//                                       disabled={!hasActionPermission}
//                                       onClick={() => {
//                                         if (
//                                           channel?.status === "NotRequested" ||
//                                           channel?.status === "Requested" ||
//                                           channel?.status === "Approved" ||
//                                           channel?.status === "Rejected"
//                                         ) {
//                                           setChannelId(channel?.id);
//                                           setRequestId(channel?.requestId);
//                                           setCompanyName(channel?.companyName);
//                                           modal && toggleModal(modal);
//                                         } else {
//                                           setChannelId(channel?.id);
//                                           setCompanyName(channel?.companyName);
//                                           setChannelType(channel?.channelType);
//                                           if (channel?.status === "Installed") {
//                                             toggleModal("credentials");
//                                           } else {
//                                             toggleModal("edit");
//                                           }
//                                         }
//                                       }}
//                                       className={`border px-2 py-1.5 font-medium text-xs disabled:opacity-50 disabled:cursor-not-allowed ${style}`}
//                                     >
//                                       {t(label)}
//                                     </button>
//                                   );
//                                 })()}
//                               {channel.status === "Connected" && (
//                                 <button
//                                   disabled={!canUpdateIntegration}
//                                   onClick={() => {
//                                     if (
//                                       channel?.companyName
//                                         ?.toLowerCase()
//                                         .includes("naqel")
//                                     ) {
//                                       setChannelType(channel.companyName);
//                                       setPlatformId(
//                                         channel?.requestId ?? channel?.id,
//                                       );
//                                       setCompanyName(channel?.companyName);
//                                       setEditValue(
//                                         "userName",
//                                         channel?.userName ?? "",
//                                       );
//                                       setEditValue(
//                                         "customerCode",
//                                         channel?.customerCode ?? "",
//                                       );
//                                       setEditValue(
//                                         "branchCode",
//                                         channel?.branchCode ?? "",
//                                       );
//                                       setEditValue("password", "");
//                                       toggleModal("edit");
//                                       return;
//                                     }

//                                     if (
//                                       channel?.companyName
//                                         ?.toLowerCase()
//                                         .includes("aramex")
//                                     ) {
//                                       setChannelType(channel.companyName);
//                                       setPlatformId(
//                                         channel?.requestId ?? channel?.id,
//                                       );
//                                       setCompanyName(channel?.companyName);
//                                       setEditValue(
//                                         "accountNumber",
//                                         channel?.accountNumber ?? "",
//                                       );
//                                       setEditValue(
//                                         "accountPin",
//                                         channel?.accountPin ?? "",
//                                       );
//                                       setEditValue(
//                                         "userName",
//                                         channel?.userName ?? "",
//                                       );
//                                       setEditValue("password", "");
//                                       setEditValue(
//                                         "accountEntity",
//                                         channel?.accountEntity ?? "",
//                                       );
//                                       setEditValue(
//                                         "accountCountryCode",
//                                         channel?.accountCountryCode ?? "",
//                                       );
//                                       setEditValue(
//                                         "paymentType",
//                                         channel?.paymentType ?? "",
//                                       );
//                                       setEditValue(
//                                         "productGroup",
//                                         channel?.productGroup ?? "",
//                                       );
//                                       toggleModal("edit");
//                                       return;
//                                     }

//                                     if (
//                                       channel?.companyName
//                                         ?.toLowerCase()
//                                         .includes("zid")
//                                     ) {
//                                       setChannelType(channel.companyName);
//                                       setPlatformId(
//                                         channel?.requestId ?? channel?.id,
//                                       );
//                                       setCompanyName(channel?.companyName);
//                                       console.log(
//                                         "Editing Zid with clientId:",
//                                         channel,
//                                       );
//                                       toggleModal("edit");
//                                       return;
//                                     }
//                                     if (
//                                       channel?.companyName
//                                         ?.toLowerCase()
//                                         .includes("j&t") ||
//                                       channel?.companyName
//                                         ?.toLowerCase()
//                                         .includes("jt express")
//                                     ) {
//                                       setChannelType(channel.companyName);
//                                       setPlatformId(
//                                         channel?.requestId ?? channel?.id,
//                                       );
//                                       setCompanyName(channel?.companyName);
//                                       setEditValue(
//                                         "customerCode",
//                                         channel?.customerCode ?? "",
//                                       );
//                                       setEditValue(
//                                         "apiAccount",
//                                         channel?.apiAccount ?? "",
//                                       );
//                                       setEditValue("privateKey", "");
//                                       toggleModal("edit");
//                                       return;
//                                     }
//                                     if (
//                                       channel?.channelType === "SHIPPING" &&
//                                       channel?.accountType === "OTHER"
//                                     ) {
//                                       setChannelType("Shipping");
//                                       setPlatformId(channel?.shippingPartnerId);
//                                     } else if (
//                                       channel?.accountType === "GWARM"
//                                     ) {
//                                       setChannelType("Connection Account");
//                                       setPlatformId(channel?.platformId);
//                                     } else if (
//                                       channel?.channelType === "SALES" &&
//                                       channel?.accountType === "SHOAPIFY"
//                                     ) {
//                                       setChannelType("Shoapify");
//                                       setPlatformId(channel?.id);
//                                     } else {
//                                       setChannelType("Sales");
//                                       setPlatformId(channel?.platformId);
//                                     }
//                                     toggleModal("edit");
//                                     setCompanyName(channel?.companyName);
//                                     setEditValue(
//                                       "authKey",
//                                       channel?.authKey ?? "",
//                                     );
//                                     setEditValue(
//                                       "serviceCode",
//                                       channel?.serviceCode ?? "",
//                                     );
//                                     setEditValue("isPudo", channel?.isPudo);
//                                     setEditValue("clientId", channel?.clientId);
//                                     setEditValue(
//                                       "secretKey",
//                                       channel?.secretKey,
//                                     );
//                                     setEditValue("appId", channel?.appId);
//                                   }}
//                                   className="bg-[#212121] text-white border rounded-md px-2 py-1.5 font-medium text-xs flex items-center gap-1 disabled:opacity-50 disabled:cursor-not-allowed"
//                                 >
//                                   <IconPencil strokeWidth={1.5} size={14} />{" "}
//                                   {t("Edit")}
//                                 </button>
//                               )}

//                               {channel?.companyName === "Salla" &&
//                                 channel.status === "Connected" && (
//                                   <button
//                                     onClick={() =>
//                                       navigate(`/pending-order/${channel.id}`)
//                                     }
//                                     className=" text-[#212121]/70 border border-[#D2D2D2] rounded-md px-4 py-2  font-medium text-sm "
//                                   >
//                                     {t("Pending Orders")}
//                                   </button>
//                                 )}
//                               {channel?.companyName === "Shopify" &&
//                                 channel.status === "Connected" && (
//                                   <button
//                                     onClick={() =>
//                                       navigate(
//                                         `/shopify-pending-order/${channel.id}`,
//                                       )
//                                     }
//                                     className=" text-[#212121]/70 border border-[#D2D2D2] rounded-md px-4 py-2  font-medium text-sm "
//                                   >
//                                     Pending Orders
//                                   </button>
//                                 )}
//                             </div>
//                           </div>
//                         </div>
//                       );
//                     })}
//               </div>
//             </div>
//           </div>

//           {/* Side Panel */}
//           {isSidebarOpen && (
//             <div className="col-span-5">
//               <div className="sticky top-4 bg-white rounded-3xl border border-gray-100 shadow-sm p-6 h-fit">
//                 {modalType !== null && (
//                   <div className="space-y-4">
//                     <div className="flex justify-between items-center ">
//                       <h2 className="text-xl font-semibold text-[#212121]">
//                         {getModalTitle()}
//                       </h2>
//                       <div className="flex items-center gap-3 ">
//                         <button
//                           type={
//                             modalType === "credentials" ? "submit" : "button"
//                           }
//                           form={
//                             modalType === "credentials"
//                               ? "credentials-form"
//                               : undefined
//                           }
//                           onClick={
//                             modalType === "credentials" ? undefined : callAction
//                           }
//                           disabled={isRequestPending || isCancelPending}
//                           className="px-4 py-2 bg-[#FBD037] text-black rounded-lg text-sm font-medium disabled:opacity-50 disabled:cursor-not-allowed"
//                         >
//                           {getActionButtonText()}
//                         </button>
//                         <button
//                           onClick={() => {
//                             setChannelType("");
//                             toggleModal(null);
//                           }}
//                           className="p-2 rounded-lg border border-[#D2D2D2] hover:bg-gray-100 transition-colors"
//                         >
//                           <IconX size={20} />
//                         </button>
//                       </div>
//                     </div>

//                     <div>{renderModalContent()}</div>
//                   </div>
//                 )}

//                 {isOpen && (
//                   <div className="space-y-4">
//                     <div className="flex items-center justify-between mb-4">
//                       <h2 className="text-xl font-semibold text-[#212121]">
//                         {t("Webhook URL")}
//                       </h2>
//                       <button
//                         onClick={() => setIsOpen(false)}
//                         disabled={isConnectionPending}
//                         className="p-2 rounded-lg border border-[#D2D2D2] hover:bg-gray-100 transition-colors"
//                       >
//                         <IconX size={20} />
//                       </button>
//                     </div>

//                     <WebhookModal webhookUrl={webhookUrl} tab={tab} />
//                   </div>
//                 )}
//               </div>
//             </div>
//           )}
//         </div>

//         {data?.totalPages > 1 && (
//           <Pagination
//             totalPages={data?.totalPages}
//             fetchData={fetchData}
//             currentPage={1}
//           />
//         )}

//         {data?.channels?.length === 0 && (
//           <div className="bg-[#FCFDF8] rounded-3xl flex flex-col items-center justify-center text-center py-12 text-gray-500">
//             <img
//               src="./img/data-not-found.png"
//               alt="No Data"
//               className="w-24 h-24 mb-4"
//             />
//             <h3 className="text-2xl font-semibold text-[#212121]">
//               {t("No Data Found")}
//             </h3>
//             <p className="text-base text-[#212121]/70 mt-1">
//               {t("Try adjusting your filters or come back later.")}
//             </p>
//           </div>
//         )}
//       </div>
//     </>
//   );
// }

/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-unused-vars */
"use client";

import React, { useEffect, useState } from "react";
import { usePermission } from "../../../hooks/usePermissionTabs";
import { useLanguage } from "../../../context/LanguageContext";
import Pagination from "../../../components/common/Pagination";
import {
  IconPencil,
  IconSearch,
  IconX,
  IconPlus,
  IconDownload,
  IconPlug,
  IconCircleCheck,
  IconCircleX,
  IconClock,
} from "@tabler/icons-react";
import RequestModal from "./RequestModal";
import CredentialsModal from "./CredentialsModal";
import EditViewCredentialsModal from "./EditViewCredentialsModal";
import IntegrationSkeleton from "../../../components/skeleton/IntegrationSkeleton";
import { useSelector } from "react-redux";
import {
  useCancelChannelMutation,
  useConnectChannelMutation,
  useEditChannelMutation,
  useEditNaqelCredentialsMutation,
  useEditAramexCredentialsMutation,
  useRequestChannelMutation,
  useEditZidCredentialsMutation,
  useEditJtCredentialsMutation,
} from "../../../apis/integrationApis";
import toast from "react-hot-toast";
import LoaderButton from "../../../components/common/LoaderButton";
import CancelModal from "./CancelModal";
import { useForm } from "react-hook-form";
import WebhookModal from "./WebhookModal";
import { useNavigate } from "react-router-dom";
import DropdownFilter from "../../../components/common/DropdownFilter";

// Extend Channel interface with all possible fields from API
interface Channel {
  id: string;
  platformId: string;
  companyName: string;
  companyLogo: string;
  appId: string;
  secretKey: string;
  clientId: string;
  description: string;
  status: ChannelStatus;
  requestId: string;
  authKey?: string;
  serviceCode?: string;
  isPudo?: string;
  channelType: string;
  shippingPartnerId: string;
  accountType?: string;
  apiVersion?: string;
  // Additional fields used in edit logic
  userName?: string;
  password?: string;
  customerCode?: string;
  branchCode?: string;
  accountNumber?: string;
  accountPin?: string;
  accountEntity?: string;
  accountCountryCode?: string;
  paymentType?: string;
  productGroup?: string;
  productType?: string;
  apiAccount?: string;
  privateKey?: string;
  clientSecret?: string;
  accessToken?: string;
  shopDomain?: string;
}

type ChannelStatus =
  | "NotRequested"
  | "Requested"
  | "Approved"
  | "Connected"
  | "Rejected"
  | "Installed";

interface Props {
  isPending: boolean;
  data: {
    channels: Channel[];
    totalPages: number;
  };
  fetchData: () => void;
  tab: string;
}

type ModalType =
  | "request"
  | "credentials"
  | "edit"
  | "cancel"
  | "webhook"
  | "install"
  | "installed"
  | null;

export default function SalesChannelTab({
  isPending,
  data,
  fetchData,
  tab,
}: Props) {
  const { t } = useLanguage();
  const { allowed: canCreateIntegration } = usePermission(
    "integration",
    "create",
  );
  const { allowed: canUpdateIntegration } = usePermission(
    "integration",
    "update",
  );
  const [modalType, setModalType] = useState<ModalType>(null);
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const [webhookUrl, setWebhookUrl] = useState<string>("");
  const [channelId, setChannelId] = useState<string>("");
  const [platformId, setPlatformId] = useState<string>("");
  const [requestId, setRequestId] = useState<string>("");
  const [companyName, setCompanyName] = useState<string>("");
  const [channelType, setChannelType] = useState<string>("");
  const isSidebarOpen = modalType !== null || isOpen;
  const [showSearch, setShowSearch] = useState<boolean>(false);
  const [value, setValue] = useState<string | undefined>("");

  const navigate = useNavigate();

  const setDropdownValue = (data: string | undefined) => {
    setValue(data);
  };

  type FormValues = {
    accountNumber?: string;
    authKey?: string;
    clientId?: string;
    secretKey: string;
    appId: string;
    serviceCode?: string;
    isPudo?: string;
    shopDomain?: string;
    accessToken?: string;
    userName?: string;
    password?: string;
    customerCode?: string;
    branchCode?: string;
    accountPin?: string;
    accountCountryCode?: string;
    accountEntity?: string;
    paymentType?: string;
    productGroup?: string;
    productType?: string;
    clientSecret?: string;
    apiAccount?: string;
    privateKey?: string;
  };

  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm<FormValues>();

  const {
    register: editRegister,
    handleSubmit: editSubmit,
    setValue: setEditValue,
    reset: editReset,
    formState: { errors: editErrors },
  } = useForm<FormValues>();

  const { mutate, isPending: isRequestPending } =
    useRequestChannelMutation(channelId);
  const { mutate: connectionMutate, isPending: isConnectionPending } =
    useConnectChannelMutation(
      channelType === "Shipping"
        ? `/smsa-connection`
        : channelType === "Shoapify"
          ? `/shoapify-connection`
          : channelType === "Connection Account"
            ? "/established/connection-two-account"
            : "",
    );
  const { mutate: editConnectionMutate } = useEditChannelMutation(
    channelType === "Shipping"
      ? `/smsa-connection/${platformId}`
      : channelType === "Shoapify"
        ? `/shoapify-connection/${platformId}`
        : channelType === "Connection Account"
          ? "/established/connection-two-account"
          : "",
  );
  const { mutate: editNaqelMutate, isPending: isNaqelEditPending } =
    useEditNaqelCredentialsMutation();
  const { mutate: editAramexMutate, isPending: isAramexEditPending } =
    useEditAramexCredentialsMutation();
  const { mutate: editZidMutate, isPending: isZidEditPending } =
    useEditZidCredentialsMutation();
  const { mutate: editJtMutate, isPending: isJtEditPending } =
    useEditJtCredentialsMutation();
  const profile = useSelector((state: any) => state.auth.profile);
  const { mutate: cancelMutate, isPending: isCancelPending } =
    useCancelChannelMutation();

  const toggleModal = (type: ModalType | null) => setModalType(type);

  const handleRequest = () => {
    if (!canCreateIntegration) {
      toast.error("You do not have permission to request integrations");
      return;
    }
    mutate(undefined, {
      onSuccess: () => {
        toggleModal(null);
        fetchData();
      },
      onError: (error) => {
        console.log(error, "error");
        toast.error(`${error}`);
      },
    });
  };

  const handleCancel = () => {
    if (!canUpdateIntegration) {
      toast.error("You do not have permission to cancel integration requests");
      return;
    }
    cancelMutate(
      { channelId, requestId },
      {
        onSuccess: () => {
          toggleModal(null);
          fetchData();
        },
        onError: (error) => {
          console.log(error, "error");
          toast.error(`${error}`);
        },
      },
    );
  };

  const handleConnect = (data: any) => {
    connectionMutate(
      { channelId, ...data },
      {
        onSuccess: (res) => {
          if (res?.webhookUrl) {
            setWebhookUrl(res?.webhookUrl);
            setIsOpen(true);
          }
          toggleModal(null);
          reset();
          fetchData();
        },
        onError: (error) => {
          console.log(error, "error");
          toast.error(`${error}`);
        },
      },
    );
  };

  const handleEdit = (data: any) => {
    const ctLower = channelType.toLowerCase();
    if (ctLower.includes("naqel")) {
      editNaqelMutate(
        {
          credentials: {
            userName: data.userName ?? "",
            password: data.password ?? "",
            customerCode: data.customerCode ?? "",
            branchCode: data.branchCode ?? "",
          },
          clientId: profile?.id ?? "",
          connectionId: platformId,
        },
        {
          onSuccess: () => {
            toast.success("Naqel credentials updated!");
            toggleModal(null);
            editReset();
            fetchData();
          },
          onError: (error) => {
            console.log(error, "error");
            toast.error(`${error}`);
          },
        },
      );
    } else if (ctLower.includes("aramex")) {
      editAramexMutate(
        {
          credentials: {
            UserName: data.userName ?? "",
            Password: data.password ?? "",
            AccountNumber: data.accountNumber ?? "",
            AccountPin: data.accountPin ?? "",
            AccountEntity: data.accountEntity ?? "",
            AccountCountryCode: data.accountCountryCode ?? "",
            PaymentType: data.paymentType ?? "",
            ProductGroup: data.productGroup ?? "",
            ProductType: data.productType ?? "",
          },
          clientId: profile?.id ?? "",
          connectionId: platformId,
        },
        {
          onSuccess: () => {
            toast.success("Aramex credentials updated!");
            toggleModal(null);
            editReset();
            fetchData();
          },
          onError: (error: any) => {
            console.log(error, "error");
            toast.error(`${error}`);
          },
        },
      );
    } else if (ctLower.includes("zid")) {
      editZidMutate(
        {
          credentials: {
            clientId: data.clientId ?? "",
            clientSecret: data.clientSecret ?? "",
            appId: data.appId ?? "",
          },
          clientId: profile?.id ?? "",
          channelId: platformId,
        },
        {
          onSuccess: () => {
            toast.success("Zid credentials updated!");
            toggleModal(null);
            editReset();
            fetchData();
          },
          onError: (error) => {
            console.log(error, "error");
            toast.error(`${error}`);
          },
        },
      );
    } else if (ctLower.includes("j&t") || ctLower.includes("jt express")) {
      editJtMutate(
        {
          credentials: {
            customerCode: data.customerCode ?? "",
            apiAccount: data.apiAccount ?? "",
            privateKey: data.privateKey ?? "",
          },
          clientId: profile?.id ?? "",
          connectionId: platformId,
        },
        {
          onSuccess: () => {
            toast.success("J&T credentials updated!");
            toggleModal(null);
            editReset();
            fetchData();
          },
          onError: (error) => {
            console.log(error, "error");
            toast.error(`${error}`);
          },
        },
      );
    } else {
      editConnectionMutate(
        { channelId, ...data, id: platformId },
        {
          onSuccess: () => {
            toggleModal(null);
            editReset();
            fetchData();
          },
          onError: (error) => {
            console.log(error, "error");
            toast.error(`${error}`);
          },
        },
      );
    }
  };

  const callAction = (): void => {
    switch (modalType) {
      case "request":
        handleRequest();
        break;
      case "cancel":
        handleCancel();
        break;
      case "credentials":
        handleSubmit(handleConnect)();
        break;
      case "edit":
        editSubmit(handleEdit)();
        break;
    }
  };

  const getModalTitle = (): string => {
    switch (modalType) {
      case "request":
        return companyName;
      case "cancel":
        return t("Cancel Request");
      case "credentials":
      case "edit":
        return companyName;
      default:
        return "";
    }
  };

  const getActionButtonText = (): string | React.ReactElement => {
    switch (modalType) {
      case "request":
        return isRequestPending ? (
          <LoaderButton text={t("Requesting...")} />
        ) : (
          t("Request Integration")
        );
      case "cancel":
        return isCancelPending ? (
          <LoaderButton text={t("Confirming...")} />
        ) : (
          t("Confirm")
        );
      case "credentials":
        return isRequestPending ? (
          <LoaderButton text={t("Submitting...")} />
        ) : tab === "Shipping" ? (
          t("Test Connection")
        ) : (
          t("Submit Credentials")
        );
      case "edit":
        return t("Update");
      default:
        return "";
    }
  };

  const renderModalContent = () => {
    switch (modalType) {
      case "request":
        return <RequestModal />;
      case "cancel":
        return <CancelModal />;
      case "credentials":
        return <CredentialsModal channelId={channelId} />;
      case "edit":
        return (
          <EditViewCredentialsModal
            register={editRegister}
            errors={editErrors}
            reset={editReset}
            tab={
              tab !== "All"
                ? tab
                : channelType === "Shipping"
                  ? "Shipping"
                  : channelType === "Shoapify"
                    ? "Shoapify"
                    : channelType === "Connection Account"
                      ? "Connection Account"
                      : "Sales"
            }
            channelType={channelType}
            clientId={profile?.id}
          />
        );
      default:
        return null;
    }
  };

  // Helper to get status color and icon
  const getStatusMeta = (status: ChannelStatus) => {
    switch (status) {
      case "Connected":
        return {
          color: "bg-green-500",
          icon: IconCircleCheck,
          label: "Connected",
        };
      case "Requested":
        return { color: "bg-yellow-500", icon: IconClock, label: "Requested" };
      case "Approved":
        return { color: "bg-blue-500", icon: IconDownload, label: "Approved" };
      case "Rejected":
        return { color: "bg-red-500", icon: IconCircleX, label: "Rejected" };
      case "Installed":
        return { color: "bg-indigo-500", icon: IconPlug, label: "Installed" };
      default:
        return { color: "bg-gray-300", icon: null, label: "Idle" };
    }
  };

  // Determine primary action icon and handler for each channel
  const getActionConfig = (channel: Channel) => {
    const status = channel.status;
    const hasPermission =
      status === "NotRequested" ||
      status === "Approved" ||
      status === "Rejected"
        ? canCreateIntegration
        : canUpdateIntegration;

    switch (status) {
      case "NotRequested":
        return {
          icon: IconPlus,
          onClick: () => {
            setChannelId(channel.id);
            setCompanyName(channel.companyName);
            toggleModal("request");
          },
          tooltip: "Request",
          disabled: !hasPermission,
        };
      case "Requested":
        return {
          icon: IconX,
          onClick: () => {
            setChannelId(channel.id);
            setRequestId(channel.requestId);
            setCompanyName(channel.companyName);
            toggleModal("cancel");
          },
          tooltip: "Cancel",
          disabled: !hasPermission,
        };
      case "Approved":
        return {
          icon: IconDownload,
          onClick: () => {
            setChannelId(channel.id);
            setCompanyName(channel.companyName);
            toggleModal("credentials");
          },
          tooltip: "Install",
          disabled: !hasPermission,
        };
      case "Installed":
        return {
          icon: IconPlug,
          onClick: () => {
            setChannelId(channel.id);
            setCompanyName(channel.companyName);
            setChannelType(channel.channelType);
            toggleModal("credentials");
          },
          tooltip: "Connect",
          disabled: !hasPermission,
        };
      case "Connected":
        return {
          icon: IconCircleCheck,
          onClick: undefined, // no action
          tooltip: "Connected",
          disabled: true,
        };
      case "Rejected":
        return {
          icon: IconPlus,
          onClick: () => {
            setChannelId(channel.id);
            setCompanyName(channel.companyName);
            toggleModal("request");
          },
          tooltip: "Request again",
          disabled: !hasPermission,
        };
      default:
        // fallback (should never happen)
        return null;
    }
  };

  // Edit action (only for Connected)
  const getEditConfig = (channel: Channel) => {
    if (channel.status !== "Connected") return null;
    return {
      onClick: () => {
        // Naqel
        if (channel?.companyName?.toLowerCase().includes("naqel")) {
          setChannelType(channel.companyName);
          setPlatformId(channel?.requestId ?? channel?.id);
          setCompanyName(channel?.companyName);
          setEditValue("userName", channel?.userName ?? "");
          setEditValue("customerCode", channel?.customerCode ?? "");
          setEditValue("branchCode", channel?.branchCode ?? "");
          setEditValue("password", "");
          toggleModal("edit");
          return;
        }
        // Aramex
        if (channel?.companyName?.toLowerCase().includes("aramex")) {
          setChannelType(channel.companyName);
          setPlatformId(channel?.requestId ?? channel?.id);
          setCompanyName(channel?.companyName);
          setEditValue("accountNumber", channel?.accountNumber ?? "");
          setEditValue("accountPin", channel?.accountPin ?? "");
          setEditValue("userName", channel?.userName ?? "");
          setEditValue("password", "");
          setEditValue("accountEntity", channel?.accountEntity ?? "");
          setEditValue("accountCountryCode", channel?.accountCountryCode ?? "");
          setEditValue("paymentType", channel?.paymentType ?? "");
          setEditValue("productGroup", channel?.productGroup ?? "");
          toggleModal("edit");
          return;
        }
        // Zid
        if (channel?.companyName?.toLowerCase().includes("zid")) {
          setChannelType(channel.companyName);
          setPlatformId(channel?.requestId ?? channel?.id);
          setCompanyName(channel?.companyName);
          // populate fields if needed; they will be empty
          toggleModal("edit");
          return;
        }
        // J&T
        if (
          channel?.companyName?.toLowerCase().includes("j&t") ||
          channel?.companyName?.toLowerCase().includes("jt express")
        ) {
          setChannelType(channel.companyName);
          setPlatformId(channel?.requestId ?? channel?.id);
          setCompanyName(channel?.companyName);
          setEditValue("customerCode", channel?.customerCode ?? "");
          setEditValue("apiAccount", channel?.apiAccount ?? "");
          setEditValue("privateKey", "");
          toggleModal("edit");
          return;
        }
        // General
        if (
          channel?.channelType === "SHIPPING" &&
          channel?.accountType === "OTHER"
        ) {
          setChannelType("Shipping");
          setPlatformId(channel?.shippingPartnerId);
        } else if (channel?.accountType === "GWARM") {
          setChannelType("Connection Account");
          setPlatformId(channel?.platformId);
        } else if (
          channel?.channelType === "SALES" &&
          channel?.accountType === "SHOAPIFY"
        ) {
          setChannelType("Shoapify");
          setPlatformId(channel?.id);
        } else {
          setChannelType("Sales");
          setPlatformId(channel?.platformId);
        }
        toggleModal("edit");
        setCompanyName(channel?.companyName);
        setEditValue("authKey", channel?.authKey ?? "");
        setEditValue("serviceCode", channel?.serviceCode ?? "");
        setEditValue("isPudo", channel?.isPudo);
        setEditValue("clientId", channel?.clientId);
        setEditValue("secretKey", channel?.secretKey);
        setEditValue("appId", channel?.appId);
      },
      disabled: !canUpdateIntegration,
    };
  };

  useEffect(() => {
    setEditValue("serviceCode", "EDDL");
  }, []);

  // Safely get channels array
  const channels = data?.channels ?? [];

  return (
    <>
      <div className="flex justify-between items-center">
        <div className=""></div>
        <div className="flex items-center gap-2 px-3 py-1.5 mb-2 mr-2 bg-slate-50/80 border border-slate-200 rounded-full text-xs font-medium text-slate-600">
          <span>
            {t("total")}: <span className="font-bold">{channels.length}</span>
          </span>
          <span className="w-px h-3 bg-slate-300"></span>
          <span>
            {t("connected")}:{" "}
            <span className="font-bold text-green-600">
              {channels.filter((c) => c.status === "Connected").length}
            </span>
          </span>
          <span className="w-px h-3 bg-slate-300"></span>
          <span>
            {t("request")}:{" "}
            <span className="font-bold text-yellow-600">
              {channels.filter((c) => c.status === "Requested").length}
            </span>
          </span>
        </div>
      </div>
      <div className="bg-gradient-to-b from-white/90 to-white/60 backdrop-blur-xl transition-all duration-300 w-ful rounded-3xl w-full">
        <div className="absolute inset-0 rounded-3xl bg-gradient-to-tr from-yellow-200/20 to-transparent pointer-events-none" />
        <div className="grid grid-cols-12 gap-6 p-2">
          <div
            className={`transition-all duration-300 ${
              isSidebarOpen ? "col-span-7" : "col-span-12"
            }`}
          >
            <div className="bg-white/20 rounded-3xl border border-gray-100 shadow-sm p-6">
              {/* Header with search and filters - keep as is */}
              <div className="flex flex-col lg:flex-row lg:items-center justify-between gap-4">
                <div></div>
                <div className="flex items-center flex-wrap gap-2.5">
                  <div
                    onClick={() => {
                      if (!showSearch) {
                        setShowSearch(true);
                      }
                    }}
                    className={`flex items-center transition-all duration-300 ease-in-out border border-slate-200 rounded-md bg-white shadow-sm h-8 ${
                      showSearch
                        ? "w-64 px-2 cursor-default"
                        : "w-8 justify-center cursor-pointer"
                    }`}
                  >
                    <button
                      onClick={(e) => {
                        e.stopPropagation();
                        setShowSearch(!showSearch);
                      }}
                      className="flex items-center justify-center text-slate-700 focus:outline-none flex-shrink-0"
                      title={t("Search")}
                    >
                      <IconSearch size={17} stroke={2.5} />
                    </button>
                    {showSearch && (
                      <>
                        <input
                          type="text"
                          placeholder={t("Search...")}
                          autoFocus
                          className="flex-1 ml-2 bg-transparent text-xs text-slate-800 placeholder-slate-400 outline-none border-none"
                        />
                        <button
                          onClick={(e) => {
                            e.stopPropagation();
                            setShowSearch(false);
                          }}
                          className="flex items-center justify-center p-0.5 ml-1 text-slate-400 hover:text-slate-600 focus:outline-none flex-shrink-0"
                          title={t("Clear & Close")}
                        >
                          <IconX size={14} stroke={2.5} />
                        </button>
                      </>
                    )}
                  </div>
                  <DropdownFilter
                    setValue={setDropdownValue}
                    value={value}
                    filterheadings={[
                      { id: "", type: "All", value: "" },
                      {
                        id: "Requested",
                        type: "Requested",
                        value: "Requested",
                      },
                      { id: "Approved", type: "Approved", value: "Approved" },
                      {
                        id: "Connected",
                        type: "Connected",
                        value: "Connected",
                      },
                    ]}
                  />
                </div>
              </div>

              {/* Cards Grid - Logo first */}
              <div
                className={
                  isSidebarOpen
                    ? "grid 2xl:grid-cols-8 lg:grid-cols-6 md:grid-cols-2 grid-cols-2 gap-6 w-full"
                    : "grid 2xl:grid-cols-12 lg:grid-cols-8 md:grid-cols-4 grid-cols-3 gap-6 w-full"
                }
              >
                {isPending
                  ? Array.from({ length: 6 }, (_, idx) => (
                      <IntegrationSkeleton key={idx} />
                    ))
                  : channels.map((channel: Channel) => {
                      const statusMeta = getStatusMeta(channel.status);
                      const StatusIcon = statusMeta.icon;
                      const action = getActionConfig(channel);
                      const editAction = getEditConfig(channel);
                      const ActionIcon = action?.icon;
                      const showEdit = editAction !== null;

                      return (
                        <div
                          key={channel?.id}
                          className="rounded-xl transition-shadow p-4 flex flex-col items-center text-center"
                        >
                          {/* Logo */}
                          {action && (
                            <div
                              onClick={action.onClick}
                              title={action.tooltip}
                              className={`w-20 h-20 rounded-lg flex items-center justify-center border-2 transition-colors cursor-pointer ${
                                action.disabled
                                  ? "opacity-40 cursor-not-allowed border-slate-200 text-slate-300 hidden"
                                  : "border-slate-200 hover:border-slate-400 hover:bg-slate-50 text-slate-600"
                              }`}
                              //  className=" rounded-full bg-gray-50 border border-gray-100 flex items-center justify-center overflow-hidden"
                            >
                              <img
                                src={
                                  channel?.companyLogo ||
                                  "https://cdn-1.webcatalog.io/catalog/salla-sa/salla-sa-icon-filled-256.webp?v=1751244872409"
                                }
                                alt={channel?.companyName}
                                className="w-full h-full object-contain p-1"
                              />
                            </div>
                          )}

                          {showEdit && (
                            <div
                              onClick={editAction.onClick}
                              title="Edit credentials"
                              className={`w-20 h-20 rounded-lg border-2 transition-colors flex items-center justify-center cursor-pointer ${
                                editAction.disabled
                                  ? "opacity-100 border cursor-not-allowed border-slate-200 text-slate-300"
                                  : "border-green-600   hover:bg-slate-50 text-slate-600"
                              }`}
                            >
                              <img
                                src={
                                  channel?.companyLogo ||
                                  "https://cdn-1.webcatalog.io/catalog/salla-sa/salla-sa-icon-filled-256.webp?v=1751244872409"
                                }
                                alt={channel?.companyName}
                                className="w-full h-full object-contain p-1"
                              />
                            </div>
                          )}

                          {/* Name */}
                          <h3 className="mt-3 text-sm font-semibold text-[#212121] truncate max-w-full">
                            {channel?.companyName}
                          </h3>

                          {/* Status dot + label */}
                          {/* <div className="flex items-center gap-1.5 mt-1.5">
                            <span
                              className={`w-2.5 h-2.5 rounded-full ${statusMeta.color}`}
                            ></span>
                            <span className="text-[11px] font-medium text-slate-500">
                              {t(statusMeta.label)}
                            </span>
                          </div> */}

                          {/* Action icons row */}
                          {/* <div className="mt-4 flex items-center gap-2">
                            {action && (
                              <button
                                onClick={action.onClick}
                                disabled={action.disabled}
                                title={action.tooltip}
                                className={`p-2 rounded-full border transition-colors ${
                                  action.disabled
                                    ? "opacity-40 cursor-not-allowed border-slate-200 text-slate-300"
                                    : "border-slate-200 hover:border-slate-400 hover:bg-slate-50 text-slate-600"
                                }`}
                              >
                                <IconPlus size={18} stroke={2} />
                              </button>
                            )}

                            {showEdit && (
                              <button
                                onClick={editAction.onClick}
                                disabled={editAction.disabled}
                                title="Edit credentials"
                                className={`p-2 rounded-full border transition-colors ${
                                  editAction.disabled
                                    ? "opacity-40 cursor-not-allowed border-slate-200 text-slate-300"
                                    : "border-slate-200 hover:border-slate-400 hover:bg-slate-50 text-slate-600"
                                }`}
                              >
                                <IconPencil size={18} stroke={2} />
                              </button>
                            )}
                          </div> */}

                          {/* Optional: Pending orders buttons for Salla/Shopify - keep if needed */}
                          {channel?.companyName === "Salla" &&
                            channel.status === "Connected" && (
                              <button
                                onClick={() =>
                                  navigate(`/pending-order/${channel.id}`)
                                }
                                className="mt-3 text-xs font-medium text-blue-600 hover:underline"
                              >
                                {t("Pending Orders")}
                              </button>
                            )}
                          {channel?.companyName === "Shopify" &&
                            channel.status === "Connected" && (
                              <button
                                onClick={() =>
                                  navigate(
                                    `/shopify-pending-order/${channel.id}`,
                                  )
                                }
                                className="mt-3 text-xs font-medium text-blue-600 hover:underline"
                              >
                                Pending Orders
                              </button>
                            )}
                        </div>
                      );
                    })}
              </div>
            </div>
          </div>

          {/* Side Panel - unchanged */}
          {isSidebarOpen && (
            <div className="col-span-5">
              <div className="sticky top-4 bg-white/20 rounded-3xl border border-gray-100 shadow-sm p-6 h-fit">
                {modalType !== null && (
                  <div className="space-y-4">
                    <div className="flex justify-between items-center ">
                      <h2 className="text-xl font-semibold text-[#212121]">
                        {getModalTitle()}
                      </h2>
                      <div className="flex items-center gap-3 ">
                        <button
                          type={
                            modalType === "credentials" ? "submit" : "button"
                          }
                          form={
                            modalType === "credentials"
                              ? "credentials-form"
                              : undefined
                          }
                          onClick={
                            modalType === "credentials" ? undefined : callAction
                          }
                          disabled={isRequestPending || isCancelPending}
                          className="px-4 py-2 bg-[#FBD037] text-black rounded-lg text-sm font-medium disabled:opacity-50 disabled:cursor-not-allowed"
                        >
                          {getActionButtonText()}
                        </button>
                        <button
                          onClick={() => {
                            setChannelType("");
                            toggleModal(null);
                          }}
                          className="p-2 rounded-lg border border-[#D2D2D2] hover:bg-gray-100 transition-colors"
                        >
                          <IconX size={20} />
                        </button>
                      </div>
                    </div>

                    <div>{renderModalContent()}</div>
                  </div>
                )}

                {isOpen && (
                  <div className="space-y-4">
                    <div className="flex items-center justify-between mb-4">
                      <h2 className="text-xl font-semibold text-[#212121]">
                        {t("Webhook URL")}
                      </h2>
                      <button
                        onClick={() => setIsOpen(false)}
                        disabled={isConnectionPending}
                        className="p-2 rounded-lg border border-[#D2D2D2] hover:bg-gray-100 transition-colors"
                      >
                        <IconX size={20} />
                      </button>
                    </div>

                    <WebhookModal webhookUrl={webhookUrl} tab={tab} />
                  </div>
                )}
              </div>
            </div>
          )}
        </div>

        {data?.totalPages > 1 && (
          <Pagination
            totalPages={data?.totalPages}
            fetchData={fetchData}
            currentPage={1}
          />
        )}

        {channels.length === 0 && !isPending && (
          <div className="bg-[#FCFDF8] rounded-3xl flex flex-col items-center justify-center text-center py-12 text-gray-500">
            <img
              src="./img/data-not-found.png"
              alt="No Data"
              className="w-24 h-24 mb-4"
            />
            <h3 className="text-2xl font-semibold text-[#212121]">
              {t("No Data Found")}
            </h3>
            <p className="text-base text-[#212121]/70 mt-1">
              {t("Try adjusting your filters or come back later.")}
            </p>
          </div>
        )}
      </div>
    </>
  );
}
